import React, { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { formatError } from "@/lib/auth";

/** Admin: sender address for password-reset emails (set once your domain is verified in Resend). */
export function EmailSettings() {
  const [s, setS] = useState(null);
  const [sender, setSender] = useState("");
  useEffect(() => { api.getEmailSettings().then((r) => { setS(r); setSender(r.sender); }).catch((e) => toast.error(formatError(e))); }, []);
  const save = async () => {
    try { const r = await api.setEmailSender(sender); setS(r); toast.success("Sender saved"); } catch (e) { toast.error(formatError(e)); }
  };
  const test = async () => {
    try { const r = await api.testEmail(); toast.success(`Test email sent to ${r.sent_to}`); } catch (e) { toast.error(formatError(e)); }
  };
  if (!s) return null;
  return (
    <Card>
      <CardContent className="p-4 space-y-3" data-testid="email-settings">
        <h3 className="font-semibold flex items-center gap-2"><Mail className="w-4 h-4 text-cyan-400" /> Password-reset email</h3>
        <p className="text-xs text-muted-foreground" data-testid="email-settings-status">
          {s.own_resend
            ? <>Sending from <strong className="text-foreground">{s.from_name} &lt;{s.sender}&gt;</strong> through your Resend account.</>
            : <>Sending through the built-in sender as <strong className="text-foreground">{s.from_name}</strong>. When your domain is verified in Resend, enter an address on it below to send from your own domain.</>}
        </p>
        <div className="flex flex-wrap gap-2">
          <Input value={sender} onChange={(e) => setSender(e.target.value.trim())} placeholder="no-reply@yourdomain.com" className="h-8 text-xs w-72" data-testid="email-sender-input" />
          <Button size="sm" onClick={save} data-testid="email-sender-save-btn">Save</Button>
          <Button size="sm" variant="outline" onClick={test} data-testid="email-test-btn">Send me a test</Button>
        </div>
        <p className="text-[11px] text-muted-foreground">Leave empty to go back to the built-in sender. The test goes to your own account email.</p>
      </CardContent>
    </Card>
  );
}
